import { useEffect, useState } from "react";

const OfficeFacilitiesView = ({ data }) => {
  const [details, setDetails] = useState({});

  useEffect(() => {
    setDetails({
      LocationCode: ["Location Code", data.locationCode],
      SquareFootage: ["Square Footage", data.squareFootage],
    });
  }, []);

  return (
    <div className="w-full">
      <div className="grid text-xs px-2 py-2 gap-y-1 md:grid-cols-2">
        {Object.values(details).map((item, i) => {
          return (
            <div key={i} className="w-full border-b border-gray-200 py-1">
              <div className="grid grid-cols-2 ml-5">
                <div className="expandedLabel fontExpand text-left -ml-4">
                  <span>{item[0]}:</span>
                </div>
                <span className="expandedData fontExpand">
                  {item[1] === null || item[1] === "NULL" ? "" : item[1]}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OfficeFacilitiesView;
